import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { errMsg, LOGO_URL } from "@/lib/api";
import { Input } from "@/components/ui/input";

const AdminLogin = () => {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (user) navigate("/admin/dashboard"); }, [user]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-choco flex items-center justify-center px-5 relative overflow-hidden grain">
      <div className="absolute inset-0 opacity-20">
        <img src="https://static.prod-images.emergentagent.com/jobs/d19db0b9-4d6c-4a45-abc6-252ca7a69ad6/images/e092efd3c64a20b116dd087926cdaa9c61a409e34d3ecad4834e51bebb51487f.jpeg" alt="" className="h-full w-full object-cover" />
      </div>
      <div className="relative w-full max-w-md bg-cream rounded-3xl p-8 sm:p-10 shadow-2xl">
        <div className="text-center mb-8">
          <img src={LOGO_URL} alt="Nel Bake House" className="h-20 w-20 rounded-full object-cover mx-auto mb-3 ring-1 ring-[#E5DFD3]" />
          <span className="font-display text-2xl font-bold text-choco">NEL BAKE HOUSE</span>
          <p className="text-[10px] uppercase tracking-[0.25em] text-goldsoft mt-1">Admin Panel</p>
        </div>
        <form onSubmit={submit} className="space-y-5">
          <div>
            <label className="text-sm font-medium text-choco">Email</label>
            <Input data-testid="admin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5 h-12 bg-white border-[#E5DFD3]" required />
          </div>
          <div>
            <label className="text-sm font-medium text-choco">Password</label>
            <Input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5 h-12 bg-white border-[#E5DFD3]" required />
          </div>
          <button data-testid="admin-login-btn" disabled={loading} className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-choco text-cream font-semibold px-6 py-3.5 hover:bg-chocodark active:scale-95 transition-[background-color,transform] disabled:opacity-60">
            {loading ? <Loader2 size={18} className="animate-spin" /> : <Lock size={16} />} Sign In
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
